//define name props for error message
const validationName = {
  companyName: "회사/단체명",
  name: "담당자 성함",
  phoneNumber: "휴대전화번호",
  userId: "아이디",
  password: "비밀번호",
  passwordConfirm: "비밀번호 확인",
  vatNumber: "사업자등록번호",
  representative: "대표자",
  conditions: "업태/업종",
  address: "주소",
  email: "세금계산서 이메일",
  licenseImage: "사업자등록증 이미지",
  recommender: "추천 파트너코드",
  cardNo: "카드번호를",
  cardPw: "카드 비밀번호를",
  expireMonth: "유효기간(월)을",
  expireYear: "유효기간(년)을",
  identifyNumber: "생년월일을"
};

const isNumber = (value) => {
  return /[0-9]/.test(value);
};

const isUpperCase = (value) => {
  return /[A-Z]/.test(value);
};

const isLowerCase = (value) => {
  return /[a-z]/.test(value);
};

const isKor = (value) => {
  return /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(value);
};

const isSpace = (value) => {
  return /\s/.test(value);
};

const customTrim = (value) => {
  value = value.replace(/ +/g, " ");
  value = value.replace(/^\s+|\s+$/g, "");
  return value;
};

//Global custom validation rules
export const validationRules = {
  validateEmail({ value }) {
    if (value.length < 4 || value.length > 255) {
      return false;
    }
    const emailCondition =
      /^[A-Za-z]([A-Za-z0-9\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])*@([a-zA-Z-]+\.)+[a-zA-Z]{1,63}/.test(
        value
      );

    if (emailCondition) return true;

    return false;
  },

  between({ value }, ...args) {
    value = customTrim(value);
    const moreCondition = value.length >= args[0];
    const lessCondition = value.length <= args[1];
    if (moreCondition && lessCondition) return true;
    return false;
  },

  passwordValidation({ value }) {
    if (value.length < 10 || value.length > 80) {
      return false;
    }
    const specialSymbols =
      /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/.test(value);

    const allConditions = [
      isNumber(value),
      specialSymbols,
      isUpperCase(value),
      isLowerCase(value)
    ];
    let totalCount = 0;
    for (let i = 0; i < allConditions.length; i++) {
      if (allConditions[i]) {
        totalCount += 1;
      }
      if (totalCount >= 2) {
        return true;
      }
    }
    return false;
  },

  idValidation({ value }) {
    if (value.length < 4 || value.length > 80) {
      return false;
    }
    const specialSymbols = /[\{\}\[\]\/?₩,;:|\)*~`#!^\+<>\$%&\\\=\(\'\"]/.test(
      value
    );

    if (specialSymbols || isKor(value) || isSpace(value)) return false;
    return true;
  },

  nameValidation({ value }) {
    const specialSymbols =
      /[\{\}\[\]\/?.,;:|\)*~`₩!^\-_+<>@\#$%&\\\=\(\'\"]/.test(value); // 영문포함
    if (specialSymbols || isNumber(value)) return false;
    return true;
  },

  recommendValidation({ value }) {
    const condition = /[\{\}\[\]\/?.₩,;:|\)*~`!^\+<>\$%&\\\=\(\'\"]/.test(
      value
    );
    if (condition || isSpace(value)) return false;
    return true;
  },
  valueLength({ value }, ...args) {
    if (value.length === args[0]) {
      return true;
    }
    return false;
  },

  phoneNumberValidation({ value }) {
    // 010 시작시 11자리

    if (/^(010)([0-9]{4})([0-9]{4})$/.test(value)) {
      return true;
    } else if (/^01([1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/.test(value)) {
      return true;
    }
    return false;
  },

  cardLengthValidation({ value, name }) {
    const lengthChecks = {
      cardNo: 14,
      cardPw: 2,
      expireMonth: 2,
      expireYear: 2,
      identifyNumber: 6
    };

    return !(name in lengthChecks) || value.length >= lengthChecks[name];
  },

  validateMinLength({ value }, ...args) {
    return value.length >= args;
  }
};

//Global custom validation messages
export const validationMsg = {
  required({ name }) {
    return ``;
  },
  between({ args }) {
    if (args[2] === "address") {
      return `올바른 사업장 주소를 입력해 주세요.`;
    }

    // return `최소 ${args[0]}글자 이상, 최대 ${args[1]}글자 이하를 입력해주세요.`;
    return `최소 ${args[0]}글자 이상 입력해 주세요.`;
  },
  lengthCondition() {
    return `숫자, 특수문자는 입력하실 수 없습니다.`;
  },
  confirm({ name, args }) {
    const condition = args[0];
    return `${validationName[condition]}와 ${validationName[name]}이 일치하지 않습니다.`;
  },
  min({ name, args }) {
    return `${validationName[name]}는 최소 ${args[0]}글자 입니다.`;
  },
  validateMinLength({ args }) {
    return `최소 ${args}글자 입력해 주세요.`;
  },
  valueLength({ name, args }) {
    return `${validationName[name]} ${args[0]}자리를 입력해 주세요.`;
  },
  email({}) {
    return `이메일 형식이어야 합니다.`;
  },
  passwordValidation({}) {
    return `영문/숫자 조합 10자 이상 입력해 주세요.`;
  },
  idValidation({ name, args }) {
    if (args[0] === "find") {
      return `4~80자의 영문, 숫자와 특수기호(-,_,@)만 입력해 주세요.`;
    }
    return `4~80자의 영문, 숫자와 특수기호(-,_,@)만 사용 가능해요.`;
  },
  nameValidation({}) {
    return `숫자, 특수문자는 입력할 수 없어요.`;
  },
  recommendValidation({}) {
    return `영문, 숫자, 특수기호(- , _ , @ , #)만 입력 가능합니다.`;
  },
  mime({}) {
    return `jpg, png, gif 등 사진 파일만 첨부 가능`;
  },
  validateEmail() {
    return `올바른 이메일 주소를 입력해 주세요.`;
  },
  phoneNumberValidation() {
    return `올바른 휴대전화번호 형식으로 입력해 주세요.`;
  },

  //카드 등록에서 사용하는 항목별 글자수 검사
  cardLengthValidation({ name, args }) {
    if (args[0] === "vatNumber")
      return `올바른 사업자등록번호를 입력해 주세요.`;
    return `올바른 ${validationName[name]} 입력해 주세요.`;
  }
};
